import router from '@/shared/router'
import { formataRotasGlobais } from '@/shared/common/functions/roteamento'
import lojas from '@/domains/shared/configuracoes/lojas/router/routes'
import usuarios from '@/domains/shared/configuracoes/usuarios/router/routes'
import gruposUsuarios from '@/domains/shared/configuracoes/grupos_usuarios/router/routes'
import permissoes from '@/domains/shared/configuracoes/permissoes/router/routes'
import planos from '@/domains/shared/configuracoes/planos/router/routes'
import dominios from '@/domains/shared/configuracoes/dominios/router/routes'
import ajuda from '@/domains/shared/auxiliares/ajuda/router/routes'
import videos_tutoriais from '@/domains/shared/auxiliares/videos_tutoriais/router/routes'
import nfe from '@/domains/notas_fiscais/nfe/router/routes'
import nfce from '@/domains/notas_fiscais/nfce/router/routes'
import nfse from '@/domains/notas_fiscais/nfse/router/routes'
import gerenciar_produtos from '@/domains/produtos/gerenciar_produtos/router/routes'
import valores_vendas from '@/domains/produtos/valores_vendas/router/routes'
import carteira from '@/domains/shared/carteira/router/routes'

import mdfeRoutes from '@/modules/mdfe/domains/mdfe/manifestos/router/routes'
import cteRoutes from '@/modules/cte/domains/cte/router/routes'
import cteCartasCorrecoesRoutes from '@/modules/cte/domains/cartas-correcoes/router/routes'
import cteTributosRoutes from '@/modules/cte/domains/tributos/router/routes'

mdfeRoutes.map(item => {
    item.path = item.path.replace('mdfe', 'emissor')
})

cteRoutes.map(item => {
    item.path = item.path.replace('cte', 'emissor')
})

cteCartasCorrecoesRoutes.map(item => {
    item.path = item.path.replace('cte', 'emissor/cte')
})

cteTributosRoutes.map(item => {
    item.path = item.path.replace('cte', 'emissor/cte')
})

let childrenRoutes = []
const paths = require.context('../domains/', true, /routes.js$/i)
const context = paths.keys().map(paths).map(m => m.default)

context.map((arr) => {
    if (arr) {
        arr.map((val) => { childrenRoutes.push(val) })
    }
})

const routes = [
    {
        path: '/emissor',
        component: () => import('@/shared/components/layout/Interno'),
        children: [
            {
                path: '/emissor/tributos',
                redirect: '/emissor/cte/tributos'
            },
            ...childrenRoutes, ...mdfeRoutes, ...cteRoutes, ...cteCartasCorrecoesRoutes, ...cteTributosRoutes],
    },

    {
        path: '/emissor/sistema/acessar_erp',
        redirect: '/inicio'
    },
    {
        path: '/emissor/transacoes/imprimir_pdf/:integracao/:nossoNumero',
        component: () => import('@/shared/components/ui/Impressao'),
        meta: {
            fullScreen: true,
            public: true
        },
    },
    {
        name: 'imprimirDamdfeHash',
        path: '/emissor/damdfe/:hash',
        component: () => import('@/shared/components/ui/Impressao'),
        meta: {
            fullScreen: true,
            public: true
        },
    },
    {
        path: '/emissor/conhecimentos/dacte/:id',
        component: () => import('@/modules/cte/domains/cte/views/ImprimirDacte'),
        meta: {
            fullScreen: true,
            public: true
        },
    },

    ...formataRotasGlobais('emissor', nfe),
    ...formataRotasGlobais('emissor', nfce),
    ...formataRotasGlobais('emissor', nfse),
    ...formataRotasGlobais('emissor', dominios),
    ...formataRotasGlobais('emissor', lojas),
    ...formataRotasGlobais('emissor', usuarios),
    ...formataRotasGlobais('emissor', gruposUsuarios),
    ...formataRotasGlobais('emissor', permissoes),
    ...formataRotasGlobais('emissor', planos),
    ...formataRotasGlobais('emissor', ajuda),
    ...formataRotasGlobais('emissor', videos_tutoriais),
    ...formataRotasGlobais('emissor', gerenciar_produtos),
    ...formataRotasGlobais('emissor', valores_vendas),
    ...formataRotasGlobais('emissor', carteira),
]

router.addRoutes(routes)

export default router
